import React from 'react'
import { Header } from '../Header'

export const HelpPage = () => {
  return (
    <>
        <div className="flex-1 h-full overflow-auto relative z-10 bg-gradient-to-b from-slate-50 to-white">
 
 <Header title={"Help"}/>

      {/* <!-- AI Model Section --> */}
    <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <span class="bg-pink-100 text-pink-800 p-2 rounded-full mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </span>
        AI Model
      </h2>
      
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-xl font-medium mb-4 text-gray-900">How to generate on-model images of your garments</h3>
        <ol class="list-decimal pl-6 space-y-2 mb-6">
          <li>Select "AI Model" from the menu</li>
          <li>Choose your processing mode: "Single" for one garment or "Multiple (Batch)" for up to 20 garments at once (Growth plan only)</li>
          <li>Upload your garment image(s) - drag and drop or click to browse</li>
          <li>Select the garment type (e.g., dress, top, bottom, or top and bottom)</li>
          <li>Choose a model and select one or more poses for your visualization</li>
          <li>Optionally select a background (a default background will be used if none selected)</li>
          <li>Click "Generate" for instant results (single mode) or "Generate Batch" for async processing (batch mode)</li>
          <li>For batch jobs, track progress on the "Batch Status" page and download results as individual images or a ZIP file</li>
        </ol>
        <div class="bg-blue-50 border-l-4 border-blue-500 p-4">
          <p class="font-medium text-blue-800"><span class="font-bold">For best results:</span> Use well-lit photos. Works best with tops, dresses, outerwear, or bottoms. Can be flat lay, on-body, or on a mannequin. For batch processing, upload garments of the same type and gender for optimal results.</p>
        </div>
      </div>
    </section>
  
  <div class="space-y-12">
    {/* <!-- Background Remover Section --> */}
    <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <span class="bg-blue-100 text-blue-800 p-2 rounded-full mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </span>
        Background Remover
      </h2>
      
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-xl font-medium mb-4 text-gray-900">How to remove backgrounds from images</h3>
        <ol class="list-decimal pl-6 space-y-2 mb-6">
          <li>Select Background Remover from the menu</li>
          <li>Upload your image using the "Upload" button</li>
          <li>Our AI will automatically detect and remove the background</li>
          <li>You can swap the background of the image with a choice from a list of available background images</li>
          <li>Download your processed image</li>
        </ol>
        <div class="bg-blue-50 border-l-4 border-blue-500 p-4">
          <p class="font-medium text-blue-800"><span class="font-bold">Tip:</span> For best results, use high-contrast images where the subject stands out clearly from the background.</p>
        </div>
      </div>
    </section>

    {/* <!-- Background Swap Section --> */}
    <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <span class="bg-purple-100 text-purple-800 p-2 rounded-full mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </span>
        Background Swap
      </h2>
      
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-xl font-medium mb-4 text-gray-900">How to change your image background</h3>
        <ol class="list-decimal pl-6 space-y-2">
          <li>First, remove the background (see above) or upload an image with a transparent background</li>
          <li>Select "Swap Background" from the tools menu</li>
          <li>Choose from our library of backgrounds or upload your own</li>
          <li>Download your final composition</li>
        </ol>
      </div>
    </section>

    {/* <!-- Image Upscaling Section -->*/}
    {/* <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
    <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <span class="bg-green-100 text-green-800 p-2 rounded-full mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
          </svg>
        </span>
        Image Upscaling
      </h2>
      
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-xl font-medium mb-4 text-gray-900">How to enhance and enlarge your images</h3>
        <ol class="list-decimal pl-6 space-y-2 mb-6">
          <li>Select Image Upscaler from the menu</li>
          <li>Upload your image (JPG, PNG formats supported)</li>
          <li>Choose your desired enlargement level (2x, 4x, etc.)</li>
          <li>Process and download your high-resolution image</li>
        </ol>
        <div class="bg-yellow-50 border-l-4 border-yellow-500 p-4">
          <p class="font-medium text-yellow-800"><span class="font-bold">Note:</span> Upscaling works best on images that are at least 300px in width/height. Very small or low-quality images may not improve significantly.</p>
        </div>
      </div>
    </section> */}
    
    {/* <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <span class="bg-indigo-100 text-indigo-800 p-2 rounded-full mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
          </svg>
        </span>
        AI Image Expansion
      </h2>
      
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-xl font-medium mb-4 text-gray-900">How to expand images beyond their original borders</h3>
        <ol class="list-decimal pl-6 space-y-2">
          <li>Select "Image Expander" from the menu</li>
          <li>Upload your image</li>
          <li>Select which direction to extend the image (e.g., left, right, top, bottom)</li>
          <li>Our AI will generate realistic content to fill the expanded areas</li>
          <li>Download your expanded image</li>
        </ol>
      </div>
    </section> */}

    
    <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-6">Frequently Asked Questions</h2>
      
      <div class="space-y-4">
        <div class="border-b border-gray-200 pb-4">
          <h3 class="text-lg font-medium text-gray-900 mb-2">What image formats do you support?</h3>
          <p class="text-gray-600">We support JPG, PNG, and WebP formats for uploads. Downloads are available in PNG (for transparent images) and JPG formats.</p>
        </div>
        
        <div class="border-b border-gray-200 pb-4">
          <h3 class="text-lg font-medium text-gray-900 mb-2">Is there a file size limit for the image to process?</h3>
          <p class="text-gray-600">Yes, the maximum file size is 10MB.</p>
        </div>

         <div class="border-b border-gray-200 pb-4">
          <h3 class="text-lg font-medium text-gray-900 mb-2">How long does it take to generate an on-model image?</h3>
          <p class="text-gray-600">Processing times vary based on image complexity and server load, but most images are processed within a few minutes.</p>
        </div>
        
        <div class="border-b border-gray-200 pb-4">
          <h3 class="text-lg font-medium text-gray-900 mb-2">How long are my processed images stored?</h3>
          <p class="text-gray-600">Images are stored for 7 days for free users and 30 days for premium users. For permanent storage, please download your images.</p>
        </div>
        
        <div class="pb-4">
          <h3 class="text-lg font-medium text-gray-900 mb-2">Can I batch process multiple images?</h3>
          <p class="text-gray-600">Yes! Batch processing is available for Growth plan subscribers. In the AI Model page, switch to "Multiple (Batch)" mode to upload and process up to 20 garments at once. Select your desired models and poses, and our system will process them asynchronously in the background. You can track progress and download all results from the Batch Status page.</p>
        </div>
      </div>
    </section>

    
    <section class="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h2 class="text-2xl font-semibold mb-4">Need More Help?</h2>
      <p class="text-gray-600 mb-4">Contact our support team:</p>
      <ul class="space-y-2 text-gray-700">
        <li class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          Email: <a href="mailto:info@gomens.ai" class="text-blue-600 hover:text-blue-800 underline">info@gomens.ai</a>
        </li>
        {/* <li class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          Live Chat: Available during business hours
        </li>
        <li class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          Community Forum: Ask other users for advice
        </li> */}
      </ul>
    </section>
  </div>
</div>
    </>
  )
}
